// extracted by mini-css-extract-plugin
export default {"subtitle":"payment-success_subtitle__+gbq+"};